// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { safeStorage } from '@/utils/safeStorage';

export const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
export const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

// Explicitly pass a storage adapter to prevent supabase-js from detecting
// window.webkit and attempting to use the WKWebView native message bridge.
// DuckDuckGo Mobile (and other iOS browsers) expose window.webkit for their own
// purposes, which tricks supabase-js into posting auth state through the native
// bridge — then throws an unhandled rejection when no handler responds.
//
// We route through safeStorage rather than window.localStorage directly: reading
// window.localStorage at module-eval time crashes app bootstrap in browsers whose
// localStorage getter throws SecurityError (privacy mode / blocked site-data).
// safeStorage exposes getItem/setItem/removeItem and degrades to no-ops when
// storage is unavailable (Sentry MILKY-WAY-PLANNER-18/19 class, at bootstrap).
export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: safeStorage,
  },
});